// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Color variables */
  --indigo: #5C6BC0;
  --purple: #8e70c1;
  --pink: #f35c86;
  --teal: #26A69A;
  --yellow: #ffd648;
  --primary: #0c83ff;
  --secondary: #247297;
  --success: #059669;
  --info: #049aad;
  --warning: #f58646;
  --danger: #EF4444;
  --white: #FFFFFF;
  --grey:#434343;
  /* Login Background */
  --login-background-overlay-color: #2869f773;
  --login-card-background-color: #ffffff61;
  --login-header-text-color: #000;
  /* Common Button  Dark:0047AB  Light:0070BB*/
  --btn-color: #0070bb;
  --btn-hover-color: #0047ab;
  --btn-border-color: #3f61b0c2;
  --btn-text-color: #fff;
  --header-background-color: #0047ab;
  /* Table Button */
  --btn-table-color: #0070bb;
  --btn-table-hover-color: #0047ab;
  --btn-table-border-color: #5060ad;
  --btn-table-text-color: #fff;
  /* Table Icon */
  --table-icon-background-color: linear-gradient(
    359deg,
    #0070bb,
    #0047ab,
    #0070bb
  );
  --table-icon-text-color: #fff;
  --table-icon-border-color: #3d61b0;
  /* Menu Background Color */
  --menu-background-color: #0070bb;
  --menu-text-icon-color: #000;
  --menu-text-icon-hover-color: #fff;
  --menu-text-icon-active-color: #fff;
  /* Home and Inbox Card Icons */
  --home-card-icon-color: #0047ab;
  --home-card-hover-color: #0047ab;
  --home-card-text-color: #fff;
  --inbox-card-hover-color: #0047ab;
  --inbox-card-text-color: #fff;
  /* Textbox text color */
  --textbox-disabled-text-color: #072f2e;
  /* Application Text Color */
  --app-text-color: #000000;
  --app-header-icon-color: #fff;
  /* Modal */
  --modal-header-color: #0047ab;
  /* Error Modal */
  --error-modal-header-color: #fd071f;
  /* Confirmation Modal */
  --confirmation-modal-header-color: #ff9129;
  --modal-header-text-color: #fff;
  --modal-header-icon-color: #fff;
  /* Radio */
  --radio--background-color: #0047ab;
  --radio--border-color: #0070bb;
}`, "",{"version":3,"sources":["webpack://./src/variables.css"],"names":[],"mappings":"AAAA;EAEE,oBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,2CAAA;EACA,wCAAA;EACA,+BAAA;EAEA,4CAAA;EACA,oBAAA;EACA,0BAAA;EACA,6BAAA;EACA,sBAAA;EAEA,kCAAA;EACA,iBAAA;EACA,0BAAA;EACA,gCAAA;EACA,iCAAA;EACA,4BAAA;EAEA,eAAA;EACA;;;;;GAAA;EAMA,6BAAA;EACA,kCAAA;EAEA,0BAAA;EACA,gCAAA;EACA,4BAAA;EACA,kCAAA;EACA,mCAAA;EAEA,8BAAA;EACA,+BAAA;EACA,gCAAA;EACA,4BAAA;EACA,iCAAA;EACA,6BAAA;EAEA,uBAAA;EACA,sCAAA;EAEA,2BAAA;EACA,yBAAA;EACA,6BAAA;EAEA,UAAA;EACA,6BAAA;EAGA,gBAAA;EACA,mCAAA;EAGE,uBAAA;EACF,0CAAA;EACA,+BAAA;EACA,+BAAA;EACA,UAAA;EACA,kCAAA;EACA,8BAAA;AARF","sourcesContent":[":root {\n  \n  /* Color variables */\n  --indigo: #5C6BC0;\n  --purple: #8e70c1;\n  --pink: #f35c86;\n  --teal: #26A69A;\n  --yellow: #ffd648;\n  --primary: #0c83ff;\n  --secondary: #247297;\n  --success: #059669;\n  --info: #049aad;\n  --warning: #f58646;\n  --danger: #EF4444;\n  --white: #FFFFFF;\n  --grey:#434343; \n  /* Login Background */\n  --login-background-overlay-color: #2869f773;\n  --login-card-background-color: #ffffff61;\n  --login-header-text-color: #000;\n\n  /* Common Button  Dark:0047AB  Light:0070BB*/\n  --btn-color: #0070bb;\n  --btn-hover-color: #0047ab;\n  --btn-border-color: #3f61b0c2;\n  --btn-text-color: #fff;\n\n  --header-background-color: #0047ab;\n  /* Table Button */\n  --btn-table-color: #0070bb;\n  --btn-table-hover-color: #0047ab;\n  --btn-table-border-color: #5060ad;\n  --btn-table-text-color: #fff;\n\n  /* Table Icon */\n  --table-icon-background-color: linear-gradient(\n    359deg,\n    #0070bb,\n    #0047ab,\n    #0070bb\n  );\n  --table-icon-text-color: #fff;\n  --table-icon-border-color: #3d61b0;\n\n  /* Menu Background Color */\n  --menu-background-color: #0070bb;\n  --menu-text-icon-color: #000;\n  --menu-text-icon-hover-color: #fff;\n  --menu-text-icon-active-color: #fff;\n\n  /* Home and Inbox Card Icons */\n  --home-card-icon-color: #0047ab;\n  --home-card-hover-color: #0047ab;\n  --home-card-text-color: #fff;\n  --inbox-card-hover-color: #0047ab;\n  --inbox-card-text-color: #fff;\n\n  /* Textbox text color */\n  --textbox-disabled-text-color: #072f2e;\n\n  /* Application Text Color */\n  --app-text-color: #000000;\n  --app-header-icon-color: #fff;\n\n  /* Modal */\n  --modal-header-color: #0047ab;\n  --modal-header-text-color: #fff;\n  --modal-header-icon-color: #fff;\n  /* Error Modal */\n  --error-modal-header-color: #fd071f;\n  --modal-header-text-color: #fff;\n  --modal-header-icon-color: #fff;\n    /* Confirmation Modal */\n  --confirmation-modal-header-color: #ff9129;\n  --modal-header-text-color: #fff;\n  --modal-header-icon-color: #fff;\n  /* Radio */\n  --radio--background-color: #0047ab;\n  --radio--border-color: #0070bb;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
